// ***********************************
// BatchMain.vue
// ***********************************
<template>
  <div id="app">
    <div class="container-fluid">
      <div>
        <router-link :to="{ name: 'BatchHome'}">List</router-link> | 
        <router-link :to="{ name: 'BatchAdd'}">Add</router-link> |
        <router-link :to="{ name: 'Profile' }">Share</router-link> |
        <router-link :to="{ name: 'Shapes' }">ShapeBrowser</router-link> |
        <router-link :to="{ name: 'API' }">API</router-link> 
      </div>
      Switch to the <router-link :to="{ name: 'Main'}">single database list view</router-link>.<br/><br/>
      


      <b-card header="Your Database Batches">
        <b-list-group>

          <b-list-group-item>
            <div>
                <b-input-group prepend="Search" size="sm" style="max-width: 400px; margin-bottom: 8px;">
                  <b-form-input v-model="searchString" placeholder="Search by name, description, or customer" @keyup.enter="doSearch"></b-form-input>
                  <b-input-group-append>
                    <b-button variant="primary" @click="doSearch">Go</b-button>
                    <b-button variant="outline-secondary" @click="clearSearch" v-if="searchString">Clear</b-button>
                  </b-input-group-append>
                </b-input-group>

                <b-pagination
                  :total-rows="batch_list.length"
                  :per-page="perPage"
                  v-model="currentInputPage"
                  size="sm"
                  align="center"
                />
                <b-table
                  :per-page="perPage"
                  :current-page="currentInputPage"
                  striped
                  hover
                  responsive
                  bordered
                  :items="batch_list"
                  :fields="inputFields"
                  :sort-by.sync="inputSortBy"
                  class="table table-sm"
                >
                  <template #cell(batchname)="row">
                    <div v-b-tooltip.hover :title="`${row.item.descr}`" >{{ row.item.batchname }}</div>
                    <img v-if="(row.item.batch_type=='ConsolidatedDB')" src="@/assets/Consolidated.png" height="20px" v-b-popover.hover="`This is a tentative new Consolidated Database containing other individual databases.`" title="Consolidated"></img>
                  </template>
                  
                  <template #cell(statusLong)="row">
                    {{ row.item.statusLong }}<br/>{{ row.item.status_reason }}
                  </template>
          
                  <template  v-slot:cell(size_button)="row">
                    <b-button 
                      size="sm"
                      :to="{ name: 'Batch', params: {batch_id: row.item.batch_id} }"
                      class="mr-1"
                    >Size</b-button>
                  </template>

                  <template  v-slot:cell(edit_button)="row">
                    <b-button 
                      size="sm"
                      :to="{ name: 'BatchEdit', params: {batch_id: row.item.batch_id, batchname: row.item.batchname,
                                                         descr: row.item.descr, customer: row.item.customer} }"
                      class="mr-1"
                    >Edit</b-button>
                  </template>
                  
                  <template  v-slot:cell(delete_button)="row">
                    <b-button 
                      size="sm"
                      :to="{ name: 'BatchDelete', params: {batch_id: row.item.batch_id} }"
                      class="mr-1"
                    >Delete</b-button>
                  </template>
          
          
                </b-table>
      
            </div>
          </b-list-group-item>
        </b-list-group>
      </b-card>
      
    </div>
  </div>
</template>    


<script>
import { API, Auth } from "aws-amplify";
export default {
  name: "app",
  props: ["user"],
  data() {
    return {
      batch_list: [
        {
          batch_id: "3",
          status: "please wait",
          statusLong: "please wait",
          descr: "",
          batch_date: "",
          customer: "Loading Data...",
          num_dbs: ""
        }
      ],
      inputSortBy: "row",
      currentInputPage: 1,
      inputFields: [
        // {batch_id: {
        //   label: "Batch ID",
        //   sortable: true
        // }},
        {customer: {
          label: "Customer",
          sortable: true
        }},
         {batchname: {
          label: "Batch",
          sortable: true
        }},
        {owner: {
          label: "Owner",
          sortable: true
        }},
        
        // {descr: {
        //   label: "Description",
        //   sortable: true
        // }},
        {num_dbs: {
          label: "Num Databases",
          sortable: true
        }},
        // {status: {
        //   label: "Status",
        //   sortable: true
        // }},
       {statusLong: {
          label: "Status",
          sortable: true
        }},
        {size_button: {
          label: "Auto-Size",
          sortable: false
        }},
        {edit_button: {
          label: "Edit",
          sortable: false
        }},
        {delete_button: {
          label: "Delete",
          sortable: false
        }}
        
      ],

      perPage: 100,
      searchString: '',
       
    };
  },
  async created() {
    // console.log("BatchMain: I am here1");
    let name = await Auth.currentAuthenticatedUser();
    this.user = name.username;
    this.email = name.attributes.email;
    
    // Remove Owner column if user is not dbayardAWS
    if (!['dbayardAWS','amzn~dbayard'].includes(this.user)) {
      this.inputFields = this.inputFields.filter(field => !field.owner);
    }
    
    var tries = 10;
    while (tries > 0) {
      await API.get("dbcsiAPI", `/dbcsi/batch`)
        .then(response => {
          // console.log("BatchMain: I am here3");
          this.batch_list = response.data;
          tries = 0;
          // console.log(this.genItems);
        })
        .catch(error => {
          console.log("BatchMain Error:", error);
          console.log("Will retry.  Attempts Left:", (tries-1));
        });

      tries -= 1;
    }

    // console.log("BatchMain: I am here4");
  },
  methods: {
    async doSearch() {
      this.batch_list = [{ batch_id: "0", customer: "Searching...", batchname: "", statusLong: "" }];
      let options = this.searchString ? {queryStringParameters: {searchString: this.searchString}} : {};
      await API.get("dbcsiAPI", `/dbcsi/batch`, options)
        .then(response => {
          this.batch_list = response.data;
        })
        .catch(error => {
          console.log("Batch Search Error:", error);
        });
    },
    clearSearch() {
      this.searchString = '';
      this.doSearch();
    }
  }

};
</script>

<style>
</style>
